import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MenuItem from "@material-ui/core/MenuItem";
import { Menu, makeStyles, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles({
  button: {
    padding: "2px 5px",
    minWidth: 0,
  },
});

function SplitButton({ buttons, isLoading }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const classes = useStyles();
  const [firstButton] = buttons;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  if (buttons.length === 0) return null;

  return (
    <>
      <ButtonGroup
        size="small"
        variant="outlined"
        color="primary"
        ref={anchorRef}
        className={classes.button}
        aria-label="split button"
      >
        <Button
          onClick={firstButton.action}
          disabled={firstButton.disabled || isLoading}
        >
          {isLoading ? (
            <CircularProgress size="1.2rem" color="#ffffff" />
          ) : (
            firstButton.text
          )}
        </Button>
        {buttons.length > 1 ? (
          <Button
            color="primary"
            size="small"
            className={classes.button}
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        ) : null}
      </ButtonGroup>
      {buttons.length > 1 ? (
        <Menu
          disableScrollLock
          anchorEl={anchorRef.current}
          getContentAnchorEl={null}
          onClose={handleClose}
          open={open}
        >
          {buttons.map((button, index) => (
            <MenuItem
              disabled={button.disabled || isLoading}
              key={button}
              onClick={() => {
                handleClose({});
                button.action();
              }}
            >
              {button.text}
            </MenuItem>
          ))}
        </Menu>
      ) : null}
    </>
  );
}

export default SplitButton;
